import { render } from "./AvailableItems.vue?vue&type=template&id=37a74510&scoped=true"
import script from "./AvailableItems.vue?vue&type=script&lang=js"
export * from "./AvailableItems.vue?vue&type=script&lang=js"

import "./AvailableItems.vue?vue&type=style&index=0&id=37a74510&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37a74510"]])

export default __exports__